import { useState } from "react";
import { Input } from "../components/Input";

import styles from "../../styles/lazy-input.module.scss";

import { If } from "./control-statements";

export default function LazyInput({
  placeholder,
  value,
  findOptions,
  onOption,
  fillText = true,
  minTextLength = 3,
  design,
}) {
  const [searching, setSearching] = useState(false);
  const [cleaned, setCleaned] = useState(true);
  const [textValue, setTextValue] = useState(value);

  const [lastScheduledSearch, setLastScheduledSearch] = useState();
  const [options, setOptions] = useState([]);

  const searchOptions = async () => {
    setOptions([]);
    setCleaned(false);

    if (textValue && textValue.length < minTextLength) {
      setSearching(false);
      return;
    }

    setSearching(true);

    if (lastScheduledSearch) {
      clearInterval(lastScheduledSearch);
      setLastScheduledSearch();
    }

    setLastScheduledSearch(
      setTimeout(async () => {
        const options = await findOptions(textValue);
        if (options.length > 0) setOptions(options);
        else setOptions([]);

        setSearching(false);
      }, 1000)
    );
  };

  const onOptionSelected = async (option) => {
    setOptions([]);
    setCleaned(true);
    setTextValue("");

    if (option.selectable === false) return;
    if (fillText) setTextValue(option.label);

    onOption(option);
  };

  return (
    <>
      <div className={styles.searchContainer}>
        <div className={styles.lazyInput}>
          <Input
            name="search"
            design={design || "three"}
            placeholder={placeholder}
            className="flex-1"
            value={textValue || ""}
            onChange={(e) => setTextValue(e.target.value)}
            onKeyUp={searchOptions}
          />
          <If cond={textValue}>
            <span
              className={styles.clear}
              onClick={() => {
                setTextValue("");
                setOptions([]);
                setCleaned(true);
              }}
            >
              <i className="fas fa-times-circle" />
            </span>
          </If>
        </div>
        <div className={styles.results}>
          <If
            cond={
              (options || []).length === 0 &&
              !searching &&
              !cleaned &&
              textValue
            }
          >
            <p className={styles.quantity}>Nenhum resultado encontrado</p>
          </If>
        </div>
        <div className={styles.results}>
          <If cond={options && options.length > 0}>
            <p className={styles.quantity}>
              Resultados encontrados ({options.length})
            </p>
            <div className={styles.inputOptions}>
              <ul>
                {options.map((option) => (
                  <li key={option.id} onClick={() => onOptionSelected(option)}>
                    <span className={styles.label}>{option.label}</span>
                    <span className={styles.name}>{option.name}</span>
                  </li>
                ))}
              </ul>
            </div>
          </If>
        </div>

        <If cond={searching}>
          <div className={styles.optionsLoading}>
            <p className={styles.quantity} />
            <ul>
              <li>
                <span />
                <span />
              </li>
              <li>
                <span />
                <span />
              </li>
            </ul>
          </div>
        </If>
      </div>
    </>
  );
}
